import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoWhite5 } from '../../assets/LogoWhite5.tsx';
import './Footer.scss';

export const Footer = () => {
    const navigate = useNavigate();
    return (
        <div className="footer">
            <div className="footer__top">
                <div className="container">
                    <div className="row justify--between">
                        <div className="footer__col footer__col--first">
                            <button
                                onClick={() => {
                                    navigate('/');
                                }}
                                className="footer__logo"
                            >
                                <div className="header__logo-image">
                                    <LogoWhite5 />
                                </div>
                            </button>
                        </div>
                        <div className="footer__col">
                            <p className="footer__title">Przydatne linki</p>
                            <a href="/profil"
className="footer__desc">
                                Profil
                            </a>
                            <a href="/regulamin"
className="footer__desc">
                                Regulamin
                            </a>
                            <a href="/polityka-prywatnosci"
className="footer__desc">
                                Polityka prywatności
                            </a>
                            <a href="/utworz-grupe"
className="footer__desc">
                                Twórz swoje testy
                            </a>
                        </div>
                        <div className="footer__col">
                            <p className="footer__title">Kontakt</p>
                            <p className="footer__desc">
                                <a href="mailTo:magdalena@licytapka.pl"
className="link">
                                    magdalena@licytapka.pl
                                </a>
                            </p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <div className="container">
                    <div className="row justify--between">
                        <p className="footer__version">v{process.env.REACT_APP_VERSION}</p> <p className="footer__bottom-text">Licytapka © {new Date().getFullYear()} Wszystkie prawa zastrzeżone</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
